<script>
  import {fade} from 'svelte/transition';
</script>
<style>
  .wrap-mask .key-mask{
    z-index: 1000000;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.5);
  }
</style>

<div class='wrap-mask'>
  <div class="key-mask"  in:fade={{duration: 100}} out:fade={{duration: 100}}/>
</div>
